import { render } from "./AnalisesCAPAG.vue?vue&type=template&id=73028437"
import script from "./AnalisesCAPAG.vue?vue&type=script&lang=js"
export * from "./AnalisesCAPAG.vue?vue&type=script&lang=js"

import "./AnalisesCAPAG.vue?vue&type=style&index=0&id=73028437&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__